import {
  ActivityLog,
  PaginatedResponse,
  Response,
  Routes,
  RouteWithDriver,
  RouteWithStops,
} from "Data/interfaces";
import { baseApi } from "./baseApi";
import { RouteForm } from "Pages/CreateRoute/createRoute";

export const routesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createRoute: builder.mutation<Response<RouteForm>, unknown>({
      query: (data) => {
        return {
          url: "routes",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    updateRoute: builder.mutation<Response<RouteForm>, unknown>({
      query: ({ id, updatedData }) => {
        return {
          url: `routes/${id}`,
          method: "PATCH",
          body: updatedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getRoutes: builder.query<
      PaginatedResponse<Routes>,
      { date: string; page: number }
    >({
      query: ({ date, page }) => {
        return {
          url: `routes?date=${date}&page=${page}`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getRouteDetails: builder.query<Response<RouteWithStops>, string | unknown>({
      query: ({ id, date }) => {
        return {
          url: `routes/${id}?date=${date}`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getPendingRoutes: builder.query<Response<Routes[]>, string | unknown>({
      query: ({ date }) => {
        return {
          url: `route/pending?date=${date}`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getActiveRoutes: builder.query<
      Response<RouteWithDriver[]>,
      string | unknown
    >({
      query: ({ date }) => {
        return {
          url: `route/active?date=${date}`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getCompletedRoutes: builder.query<
      Response<RouteWithDriver[]>,
      string | unknown
    >({
      query: ({ date }) => {
        return {
          url: `route/completed?date=${date}`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getRouteActivity: builder.query<Response<ActivityLog[]>, string | unknown>({
      query: ({ id, date }) => {
        return {
          url: `routes/${id}/activity-logs?date=${date}`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
  }),
});

export const {
  useCreateRouteMutation,
  useUpdateRouteMutation,
  useLazyGetRoutesQuery,
  useLazyGetRouteDetailsQuery,
  useLazyGetPendingRoutesQuery,
  useLazyGetActiveRoutesQuery,
  useLazyGetCompletedRoutesQuery,
  useLazyGetRouteActivityQuery,
} = routesApi;
